module.exports = __webpack_public_path__ + "c48c5a925448dbfabdac7d2538699879.mp4";